import { MyButton, MyBgPatternDecorativeCube, MyFeaturedIcon } from '@interstellar-component'

// What happens after the client signs the membership agreement (sequential
// DocuSign signing): the client's signature is only the first of two — CLIK
// reviews the application, CLIK countersigns, and only then can the company be
// activated with its CLIK credentials.
const NEXT_STEPS = [
  'CLIK reviews your company application.',
  'Once approved, CLIK countersigns the membership agreement.',
  'You enter your CLIK credentials to activate the company.',
]

function StepMembershipApplicationSubmitSuccessful({ onBackToCompanyList, signingFlow }) {
  // Envelopes from the old single-signer template are complete with the
  // client's signature alone — no CLIK countersignature to announce.
  const sequential = signingFlow !== 'single'

  return (
    <section className="w-full h-full flex items-center justify-center">
      <div className="relative flex flex-col items-center justify-center gap-8 w-full max-w-[360px] z-50">
        <div className="absolute top-1/2 left-1/2 -translate-x-[50%] -translate-y-[50%] -z-10 pointer-events-none">
          <MyBgPatternDecorativeCube />
        </div>

        <div className="flex flex-col gap-6 items-center w-full">
          <MyFeaturedIcon icon="CheckVerified03" color="Gray" size="xl" />

          <div className="flex flex-col gap-3 items-center text-center">
            <h1 className="text-[30px] font-semibold text-gray-900 leading-[38px] tracking-tight">
              Membership Application
              <br />
              Submitted Successfully
            </h1>
            {sequential ? (
              <p className="text-base text-gray-600 leading-normal">
                You have signed the membership agreement. It now goes to CLIK for review, and CLIK
                countersigns it after approving your application.
              </p>
            ) : (
              <p className="text-base text-gray-600 leading-normal">
                Your application is currently being reviewed by CLIK. You will be notified once the
                review is complete.
              </p>
            )}
          </div>

          {sequential ? (
            <ol className="flex w-full flex-col gap-2 rounded-xl border border-gray-200 bg-white p-4 text-left">
              {NEXT_STEPS.map((step, index) => (
                <li key={step} className="flex items-start gap-3 text-sm text-gray-600">
                  <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-brand/50 text-xs font-semibold text-brand/700">
                    {index + 1}
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          ) : null}
        </div>

        <div className="w-full mt-2">
          <MyButton
            type="button"
            color="primary"
            variant="filled"
            size="lg"
            expanded
            onClick={onBackToCompanyList}
          >
            <span className="text-base font-semibold">Back to List of Company</span>
          </MyButton>
        </div>
      </div>
    </section>
  )
}

export default StepMembershipApplicationSubmitSuccessful
